import React from 'react';
import { StyledInput } from './Components';

const Input = (props) => {
  return (
    <StyledInput {...props} />
  )
}

export default Input;